var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "top",
      class: { "top-sugestion": _vm.sugestion },
      on: {
        click: function($event) {
          $event.stopPropagation()
          _vm.$emit("toogleProfile")
        }
      }
    },
    [
      _c("img", {
        staticClass: "profile_picture",
        attrs: { src: _vm.profilePicture }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "professional-info",
          class: { extra_margin: _vm.topProfessional || _vm.highDemand }
        },
        [
          _c("p", { staticClass: "name" }, [_vm._v(_vm._s(_vm.fullName))]),
          _vm._v(" "),
          _c("p", { staticClass: "orders" }, [
            _vm._v(
              _vm._s(
                _vm.totalOrderCount > 0
                  ? _vm.totalOrderCount + " limpezas  realizadas"
                  : "Novo(a) profissional"
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "badges" },
            [
              _c("Badge", {
                attrs: {
                  iconPath: "/static/shield.svg",
                  tooltipMessage: "Profissional verificado",
                  sugestion: _vm.sugestion
                }
              }),
              _vm._v(" "),
              _vm.topProfessional
                ? _c("Badge", {
                    attrs: {
                      iconPath: "/static/thumb-up.svg",
                      tooltipMessage: "Profissional sugerido",
                      sugestion: _vm.sugestion
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.highDemand
                ? _c("Badge", {
                    attrs: {
                      iconPath: "/static/trending.svg",
                      tooltipMessage:
                        "Profissional em alta com agendamentos acima da média",
                      sugestion: _vm.sugestion
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rating" },
        [
          _c("Star"),
          _vm._v(" "),
          _c("div", { staticClass: "rating-number" }, [
            _vm._v("\n      " + _vm._s(_vm.rating) + " "),
            _vm.feedbacks > 3
              ? _c("span", [
                  _vm._v(
                    "(" + _vm._s(_vm.feedbacks ? _vm.feedbacks : "-") + ")"
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.coupon
        ? _c("div", { staticClass: "discount" }, [
            _vm._v(_vm._s(_vm.couponDiscount))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e638b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e638b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Card/Info.vue
// module id = null
// module chunks = 